import { NgTemplateOutlet } from '@angular/common';
import { Component, effect, input, type OnInit, signal, viewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { type ChildDevice, type DeviceAdditionalAttribute, DeviceAttributeType, type DeviceData } from '@devices';
import { CopyComponent, NoDataPlaceholderComponent, TableSearchInputComponent, TableZoomComponent } from '@ui';

import { FirmwareStatusComponent } from '../firmware-status';

@Component({
  imports: [MatCardModule, TableSearchInputComponent, TableZoomComponent, MatTableModule, MatSortModule, NoDataPlaceholderComponent, FirmwareStatusComponent, NgTemplateOutlet, CopyComponent],
  selector: 'avs-device-attributes',
  styleUrl: './device-attributes.component.scss',
  templateUrl: './device-attributes.component.html',
})
export class DeviceAttributesComponent implements OnInit {
  device = input.required<DeviceData | ChildDevice>();
  title = input('Device Attributes');

  protected search = signal('');
  protected zoom = signal<string | null>(null);
  protected dataSource: MatTableDataSource<DeviceAdditionalAttribute> = new MatTableDataSource<DeviceAdditionalAttribute>([]);
  protected displayedColumns: string[] = ['friendlyName', 'value'];

  private sort = viewChild(MatSort);

  constructor() {
    effect(() => {
      const allAttributes = this.device().additionalAttributes?.filter(
        attr => attr.attributeType === DeviceAttributeType.PROPERTY,
      ) || [];

      const searchTerm = this.search().toLowerCase();

      const filtered = allAttributes.filter(attr =>
        attr.friendlyName.toLowerCase().includes(searchTerm) ||
        (attr.value?.toLowerCase() || '').includes(searchTerm),
      );

      this.dataSource.data = filtered;
    });
  }

  ngOnInit() {
    const sortEl = this.sort();

    if (sortEl) {
      this.dataSource.sort = sortEl;
    }
  }
}
